/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchComparablePropertyRecurringCostItemDto } from './PatchComparablePropertyRecurringCostItemDto';
import {
    PatchComparablePropertyRecurringCostItemDtoFromJSON,
    PatchComparablePropertyRecurringCostItemDtoFromJSONTyped,
    PatchComparablePropertyRecurringCostItemDtoToJSON,
    PatchComparablePropertyRecurringCostItemDtoToJSONTyped,
} from './PatchComparablePropertyRecurringCostItemDto';

/**
 * 
 * @export
 * @interface UpsertComparablePropertyRequestDto
 */
export interface UpsertComparablePropertyRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    mlsId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    mlsSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    area?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    bathCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    bedCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    lng?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    listingStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    buildingName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    garageSpaces?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    hoaFeeCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    floor?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof UpsertComparablePropertyRequestDto
     */
    listDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    listPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    livingAreaSqFt?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    lotSizeSqFt?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    neighborhood?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    nonGarageSpaces?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertComparablePropertyRequestDto
     */
    styles?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    styleOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    typeOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    state?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    yearBuilt?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    renovationType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertComparablePropertyRequestDto
     */
    hasAdditionalLivingSpace?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    additionalLivingSpaceSqFt?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    soldPrice?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof UpsertComparablePropertyRequestDto
     */
    soldDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    county?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertComparablePropertyRequestDto
     */
    hasDoormanAttendance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertComparablePropertyRequestDto
     */
    isLease?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpsertComparablePropertyRequestDto
     */
    roomsTotal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertComparablePropertyRequestDto
     */
    flipTaxRemarks?: string | null;
    /**
     * 
     * @type {Array<PatchComparablePropertyRecurringCostItemDto>}
     * @memberof UpsertComparablePropertyRequestDto
     */
    recurringCosts?: Array<PatchComparablePropertyRecurringCostItemDto> | null;
}

/**
 * Check if a given object implements the UpsertComparablePropertyRequestDto interface.
 */
export function instanceOfUpsertComparablePropertyRequestDto(value: object): value is UpsertComparablePropertyRequestDto {
    return true;
}

export function UpsertComparablePropertyRequestDtoFromJSON(json: any): UpsertComparablePropertyRequestDto {
    return UpsertComparablePropertyRequestDtoFromJSONTyped(json, false);
}

export function UpsertComparablePropertyRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertComparablePropertyRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'mlsSource': json['mlsSource'] == null ? undefined : json['mlsSource'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'area': json['area'] == null ? undefined : json['area'],
        'bathCount': json['bathCount'] == null ? undefined : json['bathCount'],
        'bedCount': json['bedCount'] == null ? undefined : json['bedCount'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'listingStatus': json['listingStatus'] == null ? undefined : json['listingStatus'],
        'buildingName': json['buildingName'] == null ? undefined : json['buildingName'],
        'city': json['city'] == null ? undefined : json['city'],
        'description': json['description'] == null ? undefined : json['description'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'garageSpaces': json['garageSpaces'] == null ? undefined : json['garageSpaces'],
        'hoaFeeCents': json['hoaFeeCents'] == null ? undefined : json['hoaFeeCents'],
        'floor': json['floor'] == null ? undefined : json['floor'],
        'listDate': json['listDate'] == null ? undefined : (new Date(json['listDate'])),
        'listPrice': json['listPrice'] == null ? undefined : json['listPrice'],
        'livingAreaSqFt': json['livingAreaSqFt'] == null ? undefined : json['livingAreaSqFt'],
        'lotSizeSqFt': json['lotSizeSqFt'] == null ? undefined : json['lotSizeSqFt'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'nonGarageSpaces': json['nonGarageSpaces'] == null ? undefined : json['nonGarageSpaces'],
        'styles': json['styles'] == null ? undefined : json['styles'],
        'styleOther': json['styleOther'] == null ? undefined : json['styleOther'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeOther': json['typeOther'] == null ? undefined : json['typeOther'],
        'state': json['state'] == null ? undefined : json['state'],
        'yearBuilt': json['yearBuilt'] == null ? undefined : json['yearBuilt'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'renovationType': json['renovationType'] == null ? undefined : json['renovationType'],
        'hasAdditionalLivingSpace': json['hasAdditionalLivingSpace'] == null ? undefined : json['hasAdditionalLivingSpace'],
        'additionalLivingSpaceSqFt': json['additionalLivingSpaceSqFt'] == null ? undefined : json['additionalLivingSpaceSqFt'],
        'soldPrice': json['soldPrice'] == null ? undefined : json['soldPrice'],
        'soldDate': json['soldDate'] == null ? undefined : (new Date(json['soldDate'])),
        'county': json['county'] == null ? undefined : json['county'],
        'hasDoormanAttendance': json['hasDoormanAttendance'] == null ? undefined : json['hasDoormanAttendance'],
        'isLease': json['isLease'] == null ? undefined : json['isLease'],
        'roomsTotal': json['roomsTotal'] == null ? undefined : json['roomsTotal'],
        'flipTaxRemarks': json['flipTaxRemarks'] == null ? undefined : json['flipTaxRemarks'],
        'recurringCosts': json['recurringCosts'] == null ? undefined : ((json['recurringCosts'] as Array<any>).map(PatchComparablePropertyRecurringCostItemDtoFromJSON)),
    };
}

export function UpsertComparablePropertyRequestDtoToJSON(json: any): UpsertComparablePropertyRequestDto {
    return UpsertComparablePropertyRequestDtoToJSONTyped(json, false);
}

export function UpsertComparablePropertyRequestDtoToJSONTyped(value?: UpsertComparablePropertyRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mlsId': value['mlsId'],
        'mlsSource': value['mlsSource'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'area': value['area'],
        'bathCount': value['bathCount'],
        'bedCount': value['bedCount'],
        'lat': value['lat'],
        'lng': value['lng'],
        'listingStatus': value['listingStatus'],
        'buildingName': value['buildingName'],
        'city': value['city'],
        'description': value['description'],
        'notes': value['notes'],
        'garageSpaces': value['garageSpaces'],
        'hoaFeeCents': value['hoaFeeCents'],
        'floor': value['floor'],
        'listDate': value['listDate'] === null ? null : ((value['listDate'] as any)?.toISOString()),
        'listPrice': value['listPrice'],
        'livingAreaSqFt': value['livingAreaSqFt'],
        'lotSizeSqFt': value['lotSizeSqFt'],
        'neighborhood': value['neighborhood'],
        'nonGarageSpaces': value['nonGarageSpaces'],
        'styles': value['styles'],
        'styleOther': value['styleOther'],
        'type': value['type'],
        'typeOther': value['typeOther'],
        'state': value['state'],
        'yearBuilt': value['yearBuilt'],
        'zipCode': value['zipCode'],
        'renovationType': value['renovationType'],
        'hasAdditionalLivingSpace': value['hasAdditionalLivingSpace'],
        'additionalLivingSpaceSqFt': value['additionalLivingSpaceSqFt'],
        'soldPrice': value['soldPrice'],
        'soldDate': value['soldDate'] === null ? null : ((value['soldDate'] as any)?.toISOString()),
        'county': value['county'],
        'hasDoormanAttendance': value['hasDoormanAttendance'],
        'isLease': value['isLease'],
        'roomsTotal': value['roomsTotal'],
        'flipTaxRemarks': value['flipTaxRemarks'],
        'recurringCosts': value['recurringCosts'] == null ? undefined : ((value['recurringCosts'] as Array<any>).map(PatchComparablePropertyRecurringCostItemDtoToJSON)),
    };
}

